/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 10/9/2021
 */
import BaseObject from "@shared/BaseObject.js";

export default class Discriminator extends BaseObject {

	static create(subTypes, property = "type"){
		return {
			keepDiscriminatorProperty: true,
			discriminator: {
				property,
				subTypes
			}

		}
	}
}
